import { Locale, LanguageCode } from 'i18n/types';

export default function languageCode(locale: Locale) {
  return locale.substr(0, 2) as LanguageCode;
}
